export const style = {
  list: {
    overflow: `hidden`,
    display: `flex`
  },
  listItem: {
    flex: 1,
    display: `block`,
    width: `100%`,
    height: `100%`,
    overflow: `hidden`,

    backgroundColor: `rgba(0, 0, 0, 0)`,
    backgroundRepeat: `no-repeat`,
    backgroundSize: `cover`,
    backgroundPosition: `center`
  },
  contentContainer: {
    height: `100%`,
    alignItems: `center`
  },
  contentLeftColumn: {
    overflow: `hidden`,
    transition: `all 0.5s cubic-bezier(0.77, 0, 0.175, 1)`,
    transform: `translate3d(-1000px, 0, 0)`
  },
  contentLeftColumnActive: {
    transform: `translate3d(0, 0, 0)`
  },
  contentHeader: {
    marginLeft: `.5rem`,
    color: `white`,
    fontSize: `20px`,
    fontWeight: `700`,
    textShadow: `0px 2px 5px rgba(0, 0, 0, 0.5)`
  },
  contentSubheaderBox: {
    transition: `all 0.5s cubic-bezier(0.77, 0, 0.175, 1)`,
    transitionDelay: `0.8s`,
    transform: `translate3d(0, -1000px, 0)`
  },
  contentSubheaderBoxActive: {
    transform: `translate3d(0, 0, 0)`
  },
  contentSubheader: {
    color: `white`,
    fontSize: `58px`,
    fontWeight: `800`,
    lineHeight: `60px`
  },
  contentDescBox: {
    marginLeft: `.5rem`,
    marginTop: `.5rem`,
    transition: `all 0.5s cubic-bezier(0.77, 0, 0.175, 1)`,
    transitionDelay: `1s`,
    transform: `translate3d(0, -1000px, 0)`
  },
  contentDescBoxActive: {
    transform: `translate3d(0, 0, 0)`
  },
  contentDesc: {
    color: `white`,
    fontSize: `16px`,
    fontWeight: `100`
    // textShadow: `0px 2px 5px rgba(0, 0, 0, 0.5)`
  },
  contentButtonBox: {
    margin: `10px .5rem`
  },
  contentButtonWrapper: {
    padding: `0 5px`,
    ':first-of-type': {
      paddingRight: `5px`,
      paddingLeft: `15px`
    },
    ':last-of-type': {
      paddingLeft: `5px`,
      paddingRight: `15px`
    }
  },
  contentButton: {
    display: `block`,
    width: `100%`,
    padding: `10px 15px`,
    textAlign: `center`,
    fontSize: `14px`,
    fontWeight: 600,
    textDecoration: `none`,
    transition: `0.2s`
  },
  contentButtonWhite: {
    color: `#A94545`,
    background: `white`,
    border: `1px solid #A94545`,
    ':hover': {
      borderColor: `white`
    }
  },
  contentButtonRed: {
    color: `white`,
    background: `#ad5151`,
    border: `1px solid #A94545`,
    ':hover': {
      background: `white`,
      color: `#A94545`,
      borderColor: `white`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Slideshow/style/image.js